// declarative interface for acumen click events

function matches( target, selector ) {
  let fn;

  if ( target instanceof Element ) {
    fn = target.matches || target.matchesSelector;
    return fn.call( target, selector );
  }

  return false;
}

function delegate( el, evt, selector, callback ) {
  el.addEventListener( evt, function( ev ) {
    let target  = ev.target;

    while ( target && !matches( target, selector ) ) {
      target = target.parentNode;
    }

    if ( target ) {
      callback( ev );
    }
  }, false );
}

function getEmitter( action ) {
  return function( ev ) {
    let event = ev.target.dataset.acumenEvent;

    acumen.track( `web-${ action }-${ event }` );

    if ( window.posthog ) {
      window.posthog.capture( `starry_com:${ action }_${ event }` );
    }
  };
}

document.addEventListener( 'DOMContentLoaded', function() {

  [ 'click', 'submit' ].forEach( function( type ) {
    delegate( window, type, '[data-acumen]', getEmitter( type ) );
  });

});

export default undefined;
